/**
 * 给数字插入逗号，及添加小数位数
 * @param {Number} numb 要加逗号的数字
 * @param {Number, String} decimal 小数位数，默认auto，只接收数字及auto
 */
export function padNumber(numb, decimal = "auto") {
  let each = 0;
  let str = "";
  let floorNumb = 0;
  if (isNaN(Math.floor(numb))) return 0;
  let isMinus = Math.floor(numb) < 0;
  floorNumb = isMinus ? Math.floor(Math.abs(numb)) : Math.floor(numb);
  if (String(floorNumb).length % 3 === 0) each--;
  each += Math.floor(String(floorNumb).length / 3);
  for (let i = 0; i < each; i++) {
    if (i === 0) {
      str = str + "," + String(floorNumb).slice(-3 * (i + 1));
    } else {
      str = "," + String(floorNumb).slice(-3 * (i + 1), -3 * i) + str;
    }
  }
  str =
    String(floorNumb).slice(
      0,
      String(floorNumb).length % 3 ? String(floorNumb).length % 3 : 3
    ) + str;
  let dot = String(numb).split(".");
  if (decimal && dot.length === 2) {
    str += ".";
    if (decimal === "auto") {
      str += dot[1];
    } else {
      if (dot.length === 1) {
        for (let i = 0; i < decimal; i++) {
          str += "0";
        }
      } else {
        if (decimal > dot[1].length) {
          str += dot[1];
          for (let i = 0; i < decimal - dot[1].length; i++) {
            str += "0";
          }
        } else {
          str += dot[1].slice(0, decimal);
        }
      }
    }
  }
  if (isMinus) return "-" + str;
  return str;
}

export function sliceNumber(value, key, sl = 0, form, maxlength) {
  value = String(value);
  if (maxlength) value = value.slice(0, maxlength)
  if (value === '') {
    form[key] = value;
    return;
  }
  let ind = value.indexOf('.');
  const dotInd = value.indexOf('。');
  if (dotInd !== -1) {
    value = value.replace('。', '.')
    ind = dotInd
  }
  const dotArr = value.split('.');
  if (dotArr.length > 2) {
    const v = dotArr[0] + '.' + dotArr[1];
    form[key] = dotArr[1].length ? Number('0' + v) : v
    return;
  }
  if (ind === -1) value = Number(value) === 0 ? '0' : value;
  if (sl === 0) {
    if (value === '-') form[key] = value;
    else form[key] = isNaN(value) ? '' : Number(value);
    return ;
  }
  if (ind !== -1) {
    let lastSlice = value.slice(ind);
    let num = lastSlice.length < 3 ? Number('0' + lastSlice) === 0 ? value.slice(0, ind) + lastSlice : Number(value.slice(0, ind) + lastSlice) : Number(value.slice(0, ind) + lastSlice.slice(0, sl + 1));
    if (num === '.' || num === '-.' || num === '-') form[key] = num;
    else form[key] = isNaN(num) ? '' : num;
  } else {
    if (value === '-') form[key] = value;
    else form[key] = isNaN(value) ? '' : Number(value);
  }
}

export function toNumber(value, key, form) {
  if (isNaN(value)) {
    form[key] = ''
  } else {
    form[key] = value.length ? Number('0' + value) : '';
  }
}
